/* eslint-disable no-undef */
const keys = {
  tokenData: 'am-token-data',
  logProvider: 'log-provider',
  isTokenLoading: 'is-refresh-token-updating',
  theme: 'theme',
  generalSettings: 'general-settings',
};

export const storeTokenData = (tokenData) => {
  localStorage.setItem(keys.tokenData, JSON.stringify(tokenData));
};

export const storeLoginProvider = (provider = 'default') => {
  localStorage.setItem(keys.logProvider, JSON.stringify(provider));
};

export const getLoginProvider = () => {
  try {
    return JSON.parse(localStorage.getItem(keys.logProvider));
  } catch (e) {
    return null;
  }
};

export const getTokenData = () => {
  try {
    return JSON.parse(localStorage.getItem(keys.tokenData));
  } catch (e) {
    return null;
  }
};

export const removeTokenData = () => {
  localStorage.removeItem(keys.tokenData);
  localStorage.removeItem(keys.logProvider);
};

export const storeTokenLoading = (isLoading) => {
  localStorage.setItem(keys.isTokenLoading, JSON.stringify(isLoading));
};

export const getTokenLoading = () => {
  try {
    return JSON.parse(localStorage.getItem(keys.isTokenLoading));
  } catch (e) {
    return false;
  }
};

export const storeGeneralSettings = (data) => {
  localStorage.setItem(keys.generalSettings, JSON.stringify(data));
};

export const getGeneralSettings = () => {
  try {
    return JSON.parse(localStorage.getItem(keys.generalSettings));
  } catch (e) {
    // default values
    return {
      date_format: 'yyyy-mm-dd',
      number_format: '123,456.78',
      display_name: 'first_last',
      currency: {
        id: 121,
        name: 'USD',
        symbol: '$',
      },
      timezone: {
        id: 183,
        label: '(GMT+00:00) Europe/London',
        value: 'Europe/London',
        offset: '(GMT+00:00)',
      },
    };
  }
};

export const getGeneralSettingsCurrencyLabel = () => {
  const settingsCurrencyRaw = getGeneralSettings()?.currency ?? {
    id: 121,
    name: 'USD',
    symbol: '$',
  };
  if (settingsCurrencyRaw.symbol) {
    return settingsCurrencyRaw.symbol;
  }
  return settingsCurrencyRaw.name;
};
